export default "__VITE_ASSET__DkhveaYo__"